const translations = {
    activeIngredient: 'Active Ingredient',
    amount: 'Amount',
    carrier: 'Carrier',
    caution: 'Caution',
    completeProductName: 'Complete Product Name',
    danger: 'Danger',
    dangerousPoison: 'Dangerous Poison',
    epaRegistrationNumber: 'EPA Reg. No.',
    noProductsApplied: 'No products applied',
    notAvailable: 'N/A',
    percentInAppliedMixture: '% in Applied Mixture (as sprayed)',
    percentInProduct: '% in Product (label)',
    poison: 'Poison',
    productsApplied: 'Products Applied - Complete Name, EPA Reg. No. & Active Ingredient',
    rate: 'Rate',
    restrictedUse: 'Restricted use: {{value}}',
    signalWord: 'Signal Word',
    targetPests: 'Target pest(s)',
    warning: 'Warning'
};

export default translations;
